/* if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();

      
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
*/

if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this.kjSwapInFullImage();
    }

    kjSwapInFullImage() {
      if (!window.kjFastZoom) return;
      const mediaId = this.openedBy.getAttribute('data-media-id');
      const el = this.querySelector(`[data-media-id="${mediaId}"]`);
      const modalImg = el && (el.tagName === 'IMG' ? el : el.querySelector('img'));
      const pageImg = this.openedBy.closest('modal-opener')?.querySelector('img');
      if (!modalImg || !pageImg || modalImg.dataset.kjDone) return;

      const fullSrc = modalImg.getAttribute('src');
      const fullSrcset = modalImg.getAttribute('srcset');
      const fullSizes = modalImg.getAttribute('sizes');
      const placeholder = pageImg.currentSrc || pageImg.src;
      if (!placeholder || !fullSrc || placeholder === fullSrc) return;

      modalImg.dataset.kjDone = '1';
      modalImg.removeAttribute('loading');
      modalImg.removeAttribute('srcset');
      modalImg.src = placeholder; // already cached: shows immediately

      const loader = new Image();
      if (fullSizes) loader.sizes = fullSizes;
      if (fullSrcset) loader.srcset = fullSrcset;
      loader.src = fullSrc;
      const swap = () => {
        const c = this.querySelector('[role="document"]');
        const left = c ? c.scrollLeft : 0;
        const top = c ? c.scrollTop : 0;
        if (fullSrcset) modalImg.srcset = fullSrcset;
        modalImg.src = fullSrc;
        if (c) { c.scrollLeft = left; c.scrollTop = top; }
      };
      (loader.decode ? loader.decode() : Promise.resolve()).then(swap, swap);
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}